import { AccountManagerDelegate } from './account.manager.delegate';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { AccountManagerService } from './account.manager.service';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { HttpProviderFactory } from '../http/http-provider.factory';
import { IAppConfig } from '../http/types/IApplicationConfig';

export class AccountManagerServiceFactory {
    static create(
        config: IAppConfig,
        spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): AccountManagerService {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new AccountManagerDelegate(config, httpProvider);
        return new AccountManagerService(delegate, authenticationService);
    }
}